import { LinkIcon } from "@heroicons/react/24/outline";

interface SignLanguageURLProps {
	url: string;
	className?: string;
}

export default function SignLanguageURL({ url, className }: SignLanguageURLProps) {
	if (!url) return <></>;

	return (
		<div className={className}>
			<h4 className="font-medium">Sign Language URL</h4>
			<ul>
				<li className="flex items-center">
					<div className="flex items-center">
						<LinkIcon className="h-3 w-3 mr-2" />
						<a
							href={url}
							className="cursor-pointer"
							target="_blank"
							rel="noopener noreferrer">
							{url}
						</a>
					</div>
				</li>
			</ul>
			<p className="text-xs mt-2">
				NOTE: Measurement Incorporated does not control any of the content on the sign
				language pages.
			</p>
		</div>
	);
}
